/**
 * @author Mevan Nirosh
 * @version 0.1
 * @since 11/9/2023
 */
import React from "react"

const ConnectivityInfo = () => {
  return <div></div>
}

export default ConnectivityInfo
